import BaseEntity from '../../base/BaseEntity.model';
import Persona from '@/models/persona/persona.model';
import SolicitudCambioComposicionFamiliarDocumento from './documento.model';

export default class SolicitudCambioComposicionFamiliarInclusion extends BaseEntity {
    public solicitudCambioComposicionFamiliarId?: number;
    public personaId?: number;
    public codHogar?: string;
    public codHogarSiuben?: string;
    public razonInclusionId?: number;
    public razonInclusionOtro?: string;
    public parentescoNombre?: string;
    
    public persona?: Persona;
    public documentos?: SolicitudCambioComposicionFamiliarDocumento[];
    constructor(public hogarId?: number | undefined, public parentescoId: number | undefined = undefined) {
        super();
        this.solicitudCambioComposicionFamiliarId = undefined;
        this.personaId = undefined;
        this.persona = undefined;
        this.documentos = [];
    }
}

